import * as React from 'react'

import { makeObservable, observable, runInAction } from 'mobx'
import { observer } from 'mobx-react'

import StatusBadge from '~/client/src/shared/components/StatusBadge/StatusBadge'
import Workflow from '~/client/src/shared/models/Workflow'
import WorkflowTypesStore from '~/client/src/shared/stores/domain/WorkflowTypes.store'

import { areObjectsEqual } from '../../../utils/util'
import WorkflowBacklinks from '../../WorkflowBacklinks/WorkflowBacklinks'
import WorkflowTypeIcon from '../../WorkflowTypeIcon/WorkflowTypeIcon'
import CompactHeaderBar from '../CompactHeaderBar'

interface IProps {
  permit: Workflow
  onCloseClick: () => void
  workflowTypesStore: WorkflowTypesStore

  menuEl?: JSX.Element
  openWorkflow?: (workflow: Workflow) => void
}

@observer
export default class PermitCompactHeaderBar extends React.Component<IProps> {
  @observable private permit: Workflow = null
  @observable private workflowTypesStore: WorkflowTypesStore = null
  @observable private openWorkflow = null

  public constructor(props: IProps) {
    super(props)

    this.permit = props.permit
    this.workflowTypesStore = props.workflowTypesStore
    this.openWorkflow = props.openWorkflow
    makeObservable(this)
  }

  public componentDidUpdate(): void {
    runInAction(() => {
      if (!areObjectsEqual(this.permit, this.props.permit)) {
        this.permit = this.props.permit
      }
    })
  }

  public render() {
    const { permit, onCloseClick, menuEl } = this.props

    return (
      <CompactHeaderBar
        titleCaption={this.permitTitleCaption}
        startDate={permit?.startDate}
        endDate={permit?.endDate}
        titleIconEl={this.titleIcon}
        isCreationMode={!permit?.id}
        renderStatus={this.permitWorkflowStatusRenderer}
        onCloseClick={onCloseClick}
        menuEl={menuEl}
      />
    )
  }

  private permitWorkflowStatusRenderer = (_className: string): JSX.Element => {
    return (
      <>
        <StatusBadge
          status={this.permit?.status}
          workflowStepLevel={this.permit?.workflowStepLevel}
          isLate={this.permit?.isLate}
        />
        <WorkflowBacklinks
          workflow={this.permit}
          onWorkflowClick={this.openWorkflow}
          className="tw:flex-none"
        />
      </>
    )
  }

  private get permitTitleCaption(): string {
    if (!this.permit?.id) {
      return this.workflowTypesStore.getPermitTypeById(this.permit?.typeId)
        ?.name
    }

    return this.permit?.getCaption(this.workflowTypesStore)
  }

  private get titleIcon(): JSX.Element {
    if (this.permit.typeId) {
      return (
        <WorkflowTypeIcon
          iconName={this.permit?.getIconNameOfPermitType(
            this.workflowTypesStore,
          )}
          className="tw:flex tw:shrink-0 tw:grow-0 tw:items-center"
        />
      )
    }
  }
}
